import { ReactNode } from 'react';

import FlyMoney from '../../../assets/about/about-fly-money.png';
import MoneyPile from '../../../assets/about/about-money-pile.png';
import NFTCard from '../../../assets/about/about-nft-card.png';
import ArrowLeft from '../../../assets/about/arrow-left.png';
import ArrowRight from '../../../assets/about/arrow-right.png';
import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';

import styles from './AboutRoyaltiesDistributionSection.module.scss';

interface IRoyaltiesItemProps {
  value: string;
  children: ReactNode;
}

const RoyaltiesItem = ({ value, children }: IRoyaltiesItemProps) => {
  return (
    <li className={styles['royalties-item']}>
      <div className={styles['royalties-item__value']}>{value}</div>
      <div className={styles['royalties-item__title']}>{children}</div>
    </li>
  );
};

const AboutRoyaltiesDistributionSection = ({ mainAnimationLoaded }: { mainAnimationLoaded: boolean }) => {
  return (
    <div className={styles['section']}>
      <div className={styles['title-container']}>
        <ScrollInAnimationItem className={`${styles['arrow-container']} ${styles['arrow-container--left']}`}>
          <img src={mainAnimationLoaded ? ArrowLeft : ''} alt="" />
        </ScrollInAnimationItem>
        <ScrollInAnimationItem delay="0.2s">
          <h2>
            royalties
            <br />
            distribution
          </h2>
        </ScrollInAnimationItem>
        <ScrollInAnimationItem className={styles['arrow-mobile-container']}>
          <img src={mainAnimationLoaded ? ArrowLeft : ''} alt="" />
        </ScrollInAnimationItem>
        <ScrollInAnimationItem className={`${styles['arrow-container']} ${styles['arrow-container--right']}`}>
          <img src={mainAnimationLoaded ? ArrowRight : ''} alt="" />
        </ScrollInAnimationItem>
      </div>
      <div className={styles['content']}>
        <ScrollInAnimationItem delay="0.3s" threshold={0.3}>
          <div className={styles['section-left']}>
            <h3>
              <span>direct</span> royalties
            </h3>
            <ul>
              <RoyaltiesItem value="20%">
                Reality USD
                <br />
                Stream
              </RoyaltiesItem>
            </ul>
          </div>
        </ScrollInAnimationItem>
        <div className={styles['image-section']}>
          <ScrollInAnimationItem className={styles['fly-money-wrapper']} threshold={0.4}>
            <img
              className={styles['fly-money-image']}
              src={mainAnimationLoaded ? FlyMoney : ''}
              alt=""
              width="513"
              height="494"
            />
          </ScrollInAnimationItem>
          <ScrollInAnimationItem className={styles['nft-card-wrapper']} threshold={0.4}>
            <img
              className={styles['nft-card']}
              src={mainAnimationLoaded ? NFTCard : ''}
              alt="Reality NFT venue card"
              width="301"
              height="350"
            />
          </ScrollInAnimationItem>
        </div>
        <ScrollInAnimationItem delay="0.3s" threshold={0.3}>
          <div className={styles['section-right']}>
            <h3>
              <span>indirect</span> royalties
            </h3>
            <ul>
              <RoyaltiesItem value="20%">
                NFT trading
                <br />
                royalties
              </RoyaltiesItem>
              <RoyaltiesItem value="20%">
                NFT
                <br />
                auctions
              </RoyaltiesItem>
              <RoyaltiesItem value="30%">
                LOOT BOX
                <br />
                SALES IN APP
                <br />
                PURCHASES
              </RoyaltiesItem>
            </ul>
          </div>
        </ScrollInAnimationItem>
      </div>
      <ScrollInAnimationItem className={styles['money-pile-container']} threshold={0.1} delay="0.1s">
        <img
          className={styles['money-pile']}
          src={mainAnimationLoaded ? MoneyPile : ''}
          alt="Pile of money"
          width="1920"
          height="640"
        />
      </ScrollInAnimationItem>
    </div>
  );
};

export default AboutRoyaltiesDistributionSection;
